<template>
  <div id="infinite-list" class="main-wrapper scroll-y custom-scrollbar with-tabs view-news">

    <page-title :title="'Do pobrania'" :back="true"></page-title>

    <slide-y-up-transition :duration="700">
      <ion-button v-show="show"
                  mode="ios"
                  fill="outline"
                  size="small"
                  @click="goTo('https://portalgastro.pl/pdf/KP_Katalog_Produktow_2023.pdf')"
                  class="btn-download">Katalog piw Kompanii Piwowarskiej
      </ion-button>
    </slide-y-up-transition>

    <slide-y-up-transition :duration="800">
      <ion-button v-show="show"
                  mode="ios"
                  fill="outline"
                  size="small"
                  @click="goTo('https://portalgastro.pl/pdf/kp_cennik_2023.pdf')"
                  class="btn-download">Cennik
      </ion-button>
    </slide-y-up-transition>

    <ion-list>
      <div v-for="(item,index) in downloads" :key="index" style="background: #f2f2f2">
        <item-menu
            :index="index+1"
            :title="item.name"
            :route="'DownloadsList'"
            :disabled="item.disabled"
            :slug="item.slug">
        </item-menu>
      </div>
    </ion-list>

    <div v-if="show && downloads.length === 0" class="text-center">
      <p><b>Brak materiałów do pobrania.</b></p>
    </div>

  </div>
</template>

<script>
import api from '@/services/Api';
import goTo from '@/mixins/goto';
import PageTitle from '@/components/PageTitle.vue';
import ItemMenu from '@/items/ItemMenu';

export default {
  name: 'DownloadsIndex',
  components: {PageTitle, ItemMenu},
  mixins: [goTo],
  data() {
    return {
      show: false,
      downloads: []
    }
  },
  mounted() {
    this.getDownloads();
  },
  methods: {
    // todo refactor to vuex
    getDownloads() {
      api({url: 'downloads?per_page=100', method: 'GET'})
          .then(resp => {
            this.downloads = resp.data.data
            this.show = true;
          })
    },
  }
}
</script>

<style lang="scss" scoped>
ion-item,
ion-list {
  --background: #f2f2f2;
}

ion-list {
  padding: 0;
  margin: 0;
}

.btn-download{
  margin: 0 5px 10px;
}
</style>
